import { FetchAdapter } from "../FetchAdapter/FetchAdapter";
import { BugsnagAdapter } from "../BugsnagAdapter/index";
import Topic from 'shared/topic';

const DEFAULT_PATH = "/interactions.json";
const DEFAULT_RESPONSE = {
  capabilities: {},
  current_user: {},
  current_visitor: {},
};

const _onSuccessCallback = (res) => {
  return res.json();
};

const _onFailedCallback = (e) => {
  BugsnagAdapter.notify("Interaction", e);
  return DEFAULT_RESPONSE;
};

class Interaction {
  static requestStatus(url) {
    const urlRequest = url || DEFAULT_PATH;

    return Interaction.fetchUrl(urlRequest).then(Interaction.handleResponse);
  }

  static fetchUrl(url) {
    return FetchAdapter.get(url)
    .then(_onSuccessCallback)
    .catch(_onFailedCallback);
  }

  static handleResponse(data) {
    let finalData = Object.assign(data, {
      isUserSignedIn: Object.keys(data.current_user).length > 0,
      isUserConfirmed: data.current_user && data.current_user.account_confirmed || false,
    })

    window.isUserSignedIn = finalData.isUserSignedIn;
    window.isUserConfirmed = finalData.isUserConfirmed;
    window.currentUser = data.current_user;

    Topic.publish('user/data/loaded', data.current_user);
    document.dispatchEvent(new Event('user.data.loaded'));

    return finalData;
  }
}

export { Interaction, DEFAULT_RESPONSE, DEFAULT_PATH };
